module.exports = __webpack_public_path__ + "static/media/question.216f0a5e.xlsx";